module.exports = __webpack_public_path__ + "img/c07_unitscouta_Normal_ua.6816a9e3.webp";